<template>
    <div class="relative inline-block text-left">
        <button
            @click="open = !open"
            type="button"
            class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
            <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4">
                <path
                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                ></path>
            </svg>

            <SlideOver :show="open" @close="open = false">
                <slot></slot>
            </SlideOver>
        </button>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';

export default {
    components: { SlideOver },
    emits: ['close'],

    data() {
        return {
            open: false,
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
    },
};
</script>
